import React from 'react';
import { graphql, compose } from "react-apollo";

import * as MESSAGES from '../Lib/Messages';
import * as GraphqlTag from "../GraphQL/MutationTherapist";

import BreadCrumb from './BreadCrumb';
import Spinner from './Spinner';
import Notification from './Notification';
import * as Utils from '../Lib/Utils';
import InputError from './InputError';
import Validator from '../Lib/Validator';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'

import { convertEmptyString } from '../Lib/Utils';
import moment from "moment";

class UserProfile extends React.Component {
	subCognito = localStorage.getItem('subHandsApps')

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			errors: {},
			isError: false,
			errorMessage: '',
			states: []
		};

		this.state = {...this.getInitialState(), ...this.state};
		this.handleChange = this.handleChange.bind(this);
	}

	getInitialState = () => ({
		user: {
			id: this.subCognito,
			firstName: "",
			lastName: "",
			birthday: moment.utc().format('MM/DD/YYYY'),
			mobile: '',
			gender: '',
			address: '',
			city: '',
			state: '',
			country: 'Australia',
			updated: moment.utc().format()
		}
	});

	handleChange(event) {
		const { target: { name, value } } = event;
		const { user, errors } = this.state;

		user[name] = value;
		this.setState(user);
		if(errors[name]) {
			delete errors[name];
		}
	}

	handleCountry = (event) => {
		const { target: { name, value } } = event;
		const { user } = this.state;
		user[name] = value;

		var states = Utils.getStates(value);
		this.setState({ states });
		if(states[0] !== undefined) {
			user['state'] = states[0];
		} else {
			user['state'] = '';
		}

		this.setState(user);
	}

	handleDateChange(field, value) {
		const { user } = this.state;
		user[field] = value.format('MM/DD/YYYY');
		this.setState({ user });
	}

	isValidation() {
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;
		const { user } = this.state;
		var validator = new Validator();

		if(!validator.required(user.firstName)) {
			errors['firstName'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(!validator.required(user.lastName)) {
			errors['lastName'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		if(isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	clearForm = () => {
		this.setState(this.getInitialState());
	}

	handleSave = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		this.setState({ loading: true });

		const { updateTherapist } = this.props;
		const { user } = this.state;
		user['updated'] = moment.utc().format();

		try {
			const results = await updateTherapist(user);
			if(results.data) {
				this.setState({ errorMessage: MESSAGES.SUCCESS_UPDATE_PROFILE, isError: false });
			} else {
				this.setState({ errorMessage: MESSAGES.ERROR_UPDATE_PROFILE, isError: true });
			}
		} catch(e) {
			this.setState({ errorMessage: MESSAGES.ERROR_UPDATE_PROFILE, isError: true });
		}

		this.setState({ loading: false });
	}

	componentDidMount() {
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
		}
		var states = Utils.getStates();
		this.setState({ states });
	}

	componentWillReceiveProps(newProps) {
		const { therapistData } = newProps;
		if(therapistData) {
			this.setState({ isEdit: true });
			const { user } = this.state;
			user['firstName'] = therapistData.firstName;
			user['lastName'] = therapistData.lastName;
			user['state'] = therapistData.state;
			user['country'] = therapistData.country;

			if(therapistData.birthday) {
				user['birthday'] = therapistData.birthday;
			}
			if(therapistData.address) {
				user['address'] = therapistData.address;
			}
			if(therapistData.city) {
				user['city'] = therapistData.city;
			}
			if(therapistData.gender) {
				user['gender'] = therapistData.gender;
			}
			if(therapistData.mobile) {
				user['mobile'] = therapistData.mobile;
			}
			this.setState({ user });

			var states = Utils.getStates(therapistData.country);
			this.setState({ states });
		}
	}

	render() {
		const { loading, errors, isError, errorMessage, user, states } = this.state;
		return (
			<section role="main" className="content-body">
				<header className="page-header">
					<h2>User Profile</h2>
					<BreadCrumb title1="User" title2="User Profile" />
				</header>

				<Notification isError={isError} message={errorMessage} />

				<div className="row">
					<div className="col">
						<section className="card">
							<div className={`card-body${loading || this.props.loading ? ' loading-overlay-showing' : ''}`}>
		                        <Spinner />
								<form className="form-horizontal form-bordered" method="POST">
									<div className={`form-group row ${errors.firstName ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">First Name*</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-address-book"></i>
												</span>
												<input type="text" name="firstName" className="form-control" value={user.firstName} onChange={this.handleChange} />
											</div>
											<InputError error={errors.firstName} />
										</div>
									</div>

									<div className={`form-group row ${errors.lastName ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">Last Name*</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-address-book"></i>
												</span>
												<input type="text" name="lastName" className="form-control" value={user.lastName} onChange={this.handleChange} />
											</div>
											<InputError error={errors.lastName} />
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">Birthday</label>
										<div className="col-lg-6">
											<div className="input-group input-date">
												<span className="input-group-addon">
													<i className="fa fa-calendar-alt"></i>
												</span>
												<DatePicker
													className="form-control"
													id="birthday"
													selected={(user.birthday) ? moment(user.birthday, 'MM/DD/YYYY') : null}
													onChange={this.handleDateChange.bind(this, 'birthday')}
													showMonthDropdown
													showYearDropdown
													dropdownMode="select"
													dateFormat="MM/DD/YYYY"
												/>
											</div>
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">Phone</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-phone"></i>
												</span>
												<input type="text" name="mobile" className="form-control" value={user.mobile || ''} onChange={this.handleChange} />
											</div>
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">Gender</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-venus-mars"></i>
												</span>
												<select id="gender" name="gender" className="form-control" value={user.gender} onChange={this.handleChange}>
													<option value="Male">Male</option>
													<option value="Female">Female</option>
												</select>
											</div>
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">Address</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-home"></i>
												</span>
												<input type="text" name="address" className="form-control" value={user.address || ''} onChange={this.handleChange} />
											</div>
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">City</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-map-marker"></i>
												</span>
												<input type="text" name="city" className="form-control" value={user.city || ''} onChange={this.handleChange} />
											</div>
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">Country</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-globe"></i>
												</span>
												<select id="country" name="country" className="form-control" value={user.country} onChange={this.handleCountry}>
													{Utils.COUNTRIES.map((item, i) =>
														<option key={i} value={item.country}>{item.country}</option>
													)}
												</select>
											</div>
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">State</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-flag"></i>
												</span>
												<select id="state" name="state" className="form-control" value={user.state} onChange={this.handleChange}>
													{states.map((item, i) =>
														<option key={i} value={item}>{item}</option>
													)}
												</select>
											</div>
										</div>
									</div>

								</form>
							</div>

							<footer className="card-footer">
								<div className="row justify-content-end">
									<div className="col-sm-9">
										<button type="submit" className="btn btn-primary" onClick={this.handleSave}>Confirm</button>
										<button type="reset" className="btn btn-default" onClick={this.clearForm}>Reset</button>
									</div>
								</div>
							</footer>
						</section>
					</div>
				</div>
			</section>
    	)
	}
}

export default compose(
	graphql(GraphqlTag.QueryGetTherapist, {
		options: (props) => ({
			// fetchPolicy: 'cache-first',
			fetchPolicy: 'cache-and-network',
			variables: { id: localStorage.getItem('subHandsApps') }
		}),
		props: ({ data: { getTherapist, loading } }) => ({
			therapistData: getTherapist,
			loading
		})
 	}),
	graphql(GraphqlTag.MutationUpdateTherapist, {
		props: (props) => ({
			updateTherapist: (user) => {
				return props.mutate({
					variables: convertEmptyString(user),
					optimisticResponse: {
						__typename: 'Therapist',
					}
				})
			}
		})
	}),
)(UserProfile);
